import React from "react";
import { PropTypes } from "prop-types";
import reactWrapper from "@harbor/elements/utils/react/wrapper";
import { displayPathAnalyticsTime } from "../../../../../../../utils/displayTime";
import { useI18n } from "../../../../../../../i18n/useI18n";

const [HbrTable] = reactWrapper(["hbr-table"]);

const ChartTableView = props => {
  const { tViews } = useI18n('views');
  const anomalyRateKey = tViews('predictiveNetworks.anomalyRateOnly');
  const columns = [
    {
      prop: "entry_ts",
      name: tViews('a11yLabels.entryTimestamp'),
      sortable: true,
      size: 500,
      cellTemplate: (h, prop) => {
        return h(
          "hbr-radio",
          {
            checked:
              new Date(props.selectedBar).getTime() ===
              new Date(prop.model.entry_ts).getTime(),
            "onHbr-click": () => {
              let selectedDate = displayPathAnalyticsTime(prop.model.entry_ts);
              props.saveData(selectedDate);
            },
            "aria-label": `${tViews('a11yLabels.selectedEntryTS', { timestamp: prop.model.entry_ts })}`,
            role: "radio",
            tabIndex: 0
          },
          `${prop.model.entry_ts}`
        );
      }
    },
    {
      prop: "anomaly",
      name: tViews('a11yLabels.anomalyRatePercent'),
      sortable: true,
      size: 180
    }
  ];

  const source = props.data
    .slice()
    .sort(
      (a, b) => new Date(b.entry_ts).getTime() - new Date(a.entry_ts).getTime()
    )
    .map(item => ({
      entry_ts: item.entry_ts,
      anomaly: item[anomalyRateKey]
    }));

  return (
    <div className="ad-accessibility-table">
      <HbrTable columns={columns} headerSlot={true} source={source} />
    </div>
  );
};

ChartTableView.propTypes = {
  data: PropTypes.array.isRequired,
  saveData: PropTypes.func.isRequired,
  selectedBar: PropTypes.string
};

export default ChartTableView;
